module.exports = __webpack_public_path__ + "img/vip.e0bdb0b6.svg";